import { useMemo } from 'react'

function useLoyaltyTargetUpgradePackages(
  originPackage: App.HotelPackage,
  offer: App.Offer | undefined,
): Record<App.LoyaltyStayUpgradeType, App.Package | undefined> {
  const roomUpgradePackageUniqueKey = originPackage.loyalty.upgradeTargetsUniqueKeys?.room
  const roomUpgradePackage = roomUpgradePackageUniqueKey ? offer?.packages.find(pkg => pkg.uniqueKey === roomUpgradePackageUniqueKey) : undefined
  const packageUpgradePackageUniqueKey = originPackage.loyalty.upgradeTargetsUniqueKeys?.package
  const packageUpgradePackage = packageUpgradePackageUniqueKey ? offer?.packages.find(pkg => pkg.uniqueKey === packageUpgradePackageUniqueKey) : undefined

  return useMemo(() => ({
    room: roomUpgradePackage,
    package: packageUpgradePackage,
  }), [roomUpgradePackage, packageUpgradePackage])
}

export default useLoyaltyTargetUpgradePackages
